import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useProductTranslations } from "@jasper/translations";
import { formatTeeth } from "../../hooks/useProductDescription/teeth";

type ElementCount = { type: string; count: number };

// Summary shown under the teeth chart: « 14–16 » or « Maxillaire » in the badge, « 2 piliers · 1 pontique » next to it
export const useTeethSelectionDescription = () => {
  // formatTeeth reads the arch names from the root of the dictionary, so no keyPrefix here
  const { t } = useTranslation("product-workflows");
  const { t: translateProduct } = useProductTranslations();

  return useCallback(
    (teeth: ReadonlyArray<number>, elements: ElementCount[]) => {
      if (!teeth.length) {
        return {
          badgeContent: "-",
          description: t("steps.teeth.noToothSelected"),
        };
      }

      return {
        badgeContent: formatTeeth(teeth, t),
        description: elements
          .map(
            ({ type, count }) =>
              `${count} ${translateProduct(type, { count }).toLowerCase()}`
          )
          .join(" · "),
      };
    },
    [t, translateProduct]
  );
};
